// src-crsld/views/views.module.js

import config from 'app/config';

import homeView from './home/home.view';
import errorView from './error/error.view';
import clearCacheView from './clear-cache/clear-cache.view';

const dependencies = [
  homeView,
  errorView,
  clearCacheView,
];

export default angular
  .module(`${config.appName}.views`, dependencies)
  .name;
